export default {
  name: 'warning',
  theme: 'outline',
  icon: {
    tag: 'svg',
    attrs: { viewBox: '0 0 120 120', focusable: false },
    children: [
      {
        tag: 'path',
        attrs: {
          d: 'M60 113.333C89.4551 113.333 113.333 89.4552 113.333 60C113.333 30.5448 89.4551 6.66669 60 6.66669C30.5448 6.66669 6.66663 30.5448 6.66663 60C6.66663 89.4552 30.5448 113.333 60 113.333Z',
        },
      },
      {
        tag: 'path',
        attrs: {
          d: 'M60 33.3333C63.4368 33.3333 66.2228 36.1193 66.2228 39.556C66.2228 39.6989 66.2179 39.8417 66.208 39.9842L64.7503 61.1216C64.5781 63.6183 62.5026 65.5555 60 65.5555C57.4975 65.5555 55.422 63.6183 55.2498 61.1216L53.7921 39.9842C53.5556 36.5556 56.1433 33.5845 59.5719 33.3481C59.7144 33.3382 59.8572 33.3333 60 33.3333ZM60 73.3333C63.6819 73.3333 66.6667 76.3181 66.6667 80C66.6667 83.6819 63.6819 86.6666 60 86.6666C56.3181 86.6666 53.3334 83.6819 53.3334 80C53.3334 76.3181 56.3181 73.3333 60 73.3333Z',
          fill: 'white',
        },
      },
    ],
  },
}
